import type { Config } from "../declarations/config.d.ts";

export const giftsConfig: Config[] = [
  {
    name: "01",
    coordinates: {
      x: "0",
      y: "1060",
    },
    width: "150",
    order: 1,
    title: "Zimní špuntí olympiáda",
    description: "Pokračování bláznivé sportovní hry se špunty v hlavní roli!",
    isContest: true,
    uuid: "62ba6dc2-a948-4c7b-a8f6-1ebdffb33a96",
    type: "game",
    slug: "zimni-spunti-olympiada",
    thumbnail: "icon_activity_zimni_spunti_olympiada.png",

    idec: "",
    appLinkIOS: "https://apps.apple.com/app/id6738506003",
    appLinkAndroid:
      "https://play.google.com/store/apps/details?id=cz.ceskatelevize.zimnispuntiolympiada",
    altType: "",
    altTitle: "",
    altIdec: "",
    altUuid: "",
    altSlug: "",
    altThumbnail: "activity-placeholder.png",
    altAppLinkIOS: "",
    altAppLinkAndroid: "",
  },
  {
    name: "02",
    coordinates: {
      x: "160",
      y: "1060",
    },
    width: "150",
    order: 2,
    title: "Bludárium",
    description: "Staneš se šampiónem Bludária? Připrav se, hrajem!",
    isContest: true,
    uuid: "8c35feb9-feca-47b4-941a-723311d68028",
    type: "game",
    slug: "bludarium",
    thumbnail: "icon_activity_bludarium.png",

    idec: "",
    appLinkIOS: "",
    appLinkAndroid: "",
    altType: "game",
    altTitle: "Výprava za sněhem",
    altDescription:
      "Bedříšek, nejmenší slon na světě, by chtěl konečně jednou zažít Vánoce na sněhu.",
    altIdec: "",
    altUuid: "",
    altSlug: "",
    altThumbnail: "icon_activity_vyprava_za_snehem.png",
    altAppLinkIOS:
      "https://apps.apple.com/us/app/v%C3%BDprava-za-sn%C4%9Bhem/id6473918696",
    altAppLinkAndroid:
      "https://play.google.com/store/apps/details?id=cz.ceskatelevize.vypravazasnehem&hl=cs&pli=1",
  },
  {
    name: "03",
    coordinates: {
      x: "320",
      y: "1060",
    },
    width: "150",
    order: 3,
    title: "Příběhová Lhota: Zimní slavnosti",
    description: "Prožij s obyvateli malého městečka předvánoční atmosféru.",
    isContest: true,
    idec: "",
    type: "game",
    slug: "pribehova-lhota-zimni-slavnosti",
    thumbnail: "icon_activity_pribehova_lhota_zimni_slavnosti.png",

    uuid: "4242dd45-8702-4f4b-a5eb-1627bf8ae73f",
    appLinkIOS:
      "https://apps.apple.com/us/app/zimn%C3%AD-slavnosti/id6738653291",
    appLinkAndroid:
      "https://play.google.com/store/apps/details?id=cz.ceskatelevize.pribehovalhotazimnislavnosti",
    altType: "",
    altTitle: "",
    altIdec: "",
    altUuid: "",
    altSlug: "",
    altThumbnail: "activity-placeholder.png",
    altAppLinkIOS: "",
    altAppLinkAndroid: "",
  },
  {
    name: "04",
    coordinates: {
      x: "480",
      y: "1060",
    },
    width: "150",
    order: 4,
    title: "Vánoce a pohádky v AZ kvízu",
    isContest: false,
    uuid: "cffd4c65-63be-4c60-90ee-60f0d2315c84",
    type: "game",
    slug: "vanoce-a-pohadky-v-az-kvizu",
    thumbnail: "icon_activity_vanoce_a_pohadky_v_az_kvizu.png",

    description: "Nesmrtelná klasika! AZ kvíz, tentokrát na vánoční téma.",

    idec: "",
    appLinkIOS: "",
    appLinkAndroid: "",
    altType: "game",
    altTitle: "",
    altIdec: "",
    altUuid: "",
    altSlug: "",
    altThumbnail: "activity-placeholder.png",
    altAppLinkIOS: "/test",
    altAppLinkAndroid: "",
  },
  {
    name: "05",
    coordinates: {
      x: "640",
      y: "1060",
    },
    width: "150",
    order: 5,
    title: "Císařův kupec",
    isContest: true,
    uuid: "0b04f273-f00a-43f7-bc11-cf31502d7591",
    type: "game",
    slug: "cisaruv-kupec",
    thumbnail: "icon_activity_cisaruv_kupec.png",

    description: "Cestuj po českém království za vlády Rudolfa II. a zbohatni!",

    idec: "",
    appLinkIOS: "https://apps.apple.com/us/app/id6738505807",
    appLinkAndroid:
      "https://play.google.com/store/apps/details?id=cz.ceskatelevize.cisaruvkupec",
    altType: "game",
    altTitle: "",
    altIdec: "",
    altUuid: "",
    altSlug: "",
    altThumbnail: "activity-placeholder.png",
    altAppLinkIOS: "",
    altAppLinkAndroid: "/test",
  },
  {
    name: "06",
    coordinates: {
      x: "800",
      y: "1060",
    },
    width: "150",
    order: 6,
    title: "Tvořivý duch Vánoc",
    description: "Probuď v sobě tvůrčího ducha a pusť se do vyrábění.",
    isContest: false,
    uuid: "7e10cfea-d586-4847-a0c6-08a833c991b0",
    type: "game",
    slug: "tvorivy-duch-vanoc",
    thumbnail: "icon_activity_tvorivy_duch_vanoc.png",

    idec: "",
    appLinkIOS: "",
    appLinkAndroid: "",
    altType: "",
    altTitle: "",
    altIdec: "",
    altUuid: "",
    altSlug: "",
    altThumbnail: "activity-placeholder.png",
    altAppLinkIOS: "",
    altAppLinkAndroid: "",
  },
  {
    name: "07",
    coordinates: {
      x: "960",
      y: "1060",
    },
    width: "150",
    order: 7,
    title: "Domečkov",
    description: "Postav si svůj domek přesně tak, jak si ho představuješ.",
    isContest: false,
    uuid: "9380672a-9432-439c-bc1a-0f1d4b9a387f",
    type: "game",
    slug: "domeckov",
    thumbnail: "icon_activity_domeckov.png",

    idec: "",
    appLinkIOS: "https://apps.apple.com/cz/app/dome%C4%8Dkov/id6738698983",
    appLinkAndroid:
      "https://play.google.com/store/apps/details?id=cz.ceskatelevize.domeckov",
    altType: "",
    altTitle: "",
    altIdec: "",
    altUuid: "",
    altSlug: "",
    altThumbnail: "activity-placeholder.png",
    altAppLinkIOS: "",
    altAppLinkAndroid: "",
  },
  {
    name: "08",
    coordinates: {
      x: "1120",
      y: "1060",
    },
    width: "150",
    order: 8,
    title: "Viky hledá poklady",
    isContest: true,
    uuid: "2ff5ed40-a273-46de-b48e-c0963a8e84ca",
    type: "game",
    slug: "viky-hleda-poklady",
    thumbnail: "icon_activity_viky_hleda_poklady.png",

    description: "Sova Viky pátrá po ukradených pokladech sysla Serváce.",

    idec: "",
    appLinkIOS:
      "https://apps.apple.com/us/app/viky-hled%C3%A1-poklady/id6739010426",
    appLinkAndroid:
      "https://play.google.com/store/apps/details?id=cz.ceskatelevize.vikyhledapoklady&pli=1",
    altType: "",
    altTitle: "",
    altIdec: "",
    altUuid: "",
    altSlug: "",
    altThumbnail: "activity-placeholder.png",
    altAppLinkIOS: "",
    altAppLinkAndroid: "",
  },
  {
    name: "09",
    coordinates: {
      x: "1280",
      y: "1060",
    },
    width: "150",
    order: 9,
    title: "Pohlednice",
    description: "Popřej kamarádům a nebo rodině hezké svátky.",
    isContest: false,
    uuid: "3ae83573-6e2f-413b-813d-a3c256e140f6",
    type: "game",
    slug: "pohlednice",
    thumbnail: "icon_activity_pohlednice.png",

    idec: "",
    appLinkIOS: "",
    appLinkAndroid: "",
    altType: "",
    altTitle: "",
    altIdec: "",
    altUuid: "",
    altSlug: "",
    altThumbnail: "activity-placeholder.png",
    altAppLinkIOS: "",
    altAppLinkAndroid: "",
  },
  {
    name: "10",
    coordinates: {
      x: "1440",
      y: "1060",
    },
    width: "150",
    order: 10,
    title: "Vojta špunty nevypeče",
    description: "Vytvoř si s Vojtou originální cukroví.",
    isContest: false,
    uuid: "",
    type: "video",
    slug: "vojta-spunty-nevypece",
    thumbnail: "icon_activity_vojta_spunty_nevypece.png",

    idec: "224 938 00004/2012",
    appLinkIOS: "",
    appLinkAndroid: "",
    altType: "",
    altTitle: "",
    altIdec: "",
    altUuid: "",
    altSlug: "",
    altThumbnail: "activity-placeholder.png",
    altAppLinkIOS: "",
    altAppLinkAndroid: "",
  },
  {
    name: "11",
    coordinates: {
      x: "1600",
      y: "1060",
    },
    width: "150",
    order: 11,
    title: "Země snů",
    description: "Chceš si postavit vlastní zemi? Tak to jsi tu správně!",
    isContest: false,
    uuid: "530dfbc3-5078-476c-b6b9-d8f9179ebf69",
    type: "game",
    slug: "zeme-snu",
    thumbnail: "icon_activity_zeme_snu.png",

    idec: "",
    appLinkIOS: "https://apps.apple.com/cz/app/zem%C4%9B-sn%C5%AF/id6738699264",
    appLinkAndroid:
      "https://play.google.com/store/apps/details?id=cz.ceskatelevize.zemesnu",
    altType: "",
    altTitle: "",
    altIdec: "",
    altUuid: "",
    altSlug: "",
    altThumbnail: "activity-placeholder.png",
    altAppLinkIOS: "",
    altAppLinkAndroid: "",
  },
  {
    name: "12",
    coordinates: {
      x: "1760",
      y: "1060",
    },
    width: "150",
    order: 12,
    title: "Sněžný drak",
    isContest: false,
    uuid: "",
    type: "video",
    slug: "snezny-drak",
    thumbnail: "icon_activity_snezny_drak.png",

    description: "Láska hory přenáší. A někdy proměňuje draky v prince!",

    idec: "311 291 31002",
    appLinkIOS: "",
    appLinkAndroid: "",
    altType: "",
    altTitle: "",
    altIdec: "",
    altUuid: "",
    altSlug: "",
    altThumbnail: "activity-placeholder.png",
    altAppLinkIOS: "",
    altAppLinkAndroid: "",
  },
  {
    name: "13",
    coordinates: {
      x: "1920",
      y: "1060",
    },
    width: "150",
    order: 13,
    title: "Popletená zvířátka",
    description: "Zvířátkům někdo zaměnil hlasy, pomůžeš jim je vrátit zpátky?",
    isContest: false,
    uuid: "70328f01-f0fb-4565-ab18-5685cf2a50b4",
    type: "game",
    slug: "popletena-zviratka",
    thumbnail: "icon_activity_popletena_zviratka.png",

    idec: "",
    appLinkIOS: "https://apps.apple.com/us/app/id6738917611",
    appLinkAndroid:
      "https://play.google.com/store/apps/details?id=cz.ceskatelevize.popletenazviratka",
    altType: "",
    altTitle: "",
    altIdec: "",
    altUuid: "",
    altSlug: "",
    altThumbnail: "activity-placeholder.png",
    altAppLinkIOS: "",
    altAppLinkAndroid: "",
  },
  {
    name: "14",
    coordinates: {
      x: "2080",
      y: "1060",
    },
    width: "150",
    order: 14,
    title: "Poznej znělku",
    description: "Znáš všechny znělky na Déčku? Zahraj si a staň se šampiónem!",
    isContest: true,
    uuid: "71cd9f5b-4d05-49af-98fb-a555a0889e52",
    type: "game",
    slug: "poznej-znelku",
    thumbnail: "icon_activity_poznej_znelku.png",

    idec: "",
    appLinkIOS: "https://apps.apple.com/us/app/poznej-zn%C4%9Blku/id6739222503",
    appLinkAndroid:
      "https://play.google.com/store/apps/details?id=cz.ceskatelevize.poznejznelku&hl=en_ZA",
    altType: "",
    altTitle: "",
    altIdec: "",
    altUuid: "",
    altSlug: "",
    altThumbnail: "activity-placeholder.png",
    altAppLinkIOS: "",
    altAppLinkAndroid: "",
  },
  {
    name: "15",
    coordinates: {
      x: "2240",
      y: "1060",
    },
    width: "150",
    order: 15,
    title: "Ředisaurus Rex: Dračí lóže",
    description: "Dinosauří škola v zajetí draků. Kdo poničil sochu královny?",
    isContest: true,
    uuid: "4e50a6b7-f552-4dd6-af57-9daa43417fa4",
    type: "game",
    slug: "redisaurus-rex-draci-loze",
    thumbnail: "icon_activity_redisaurus_rex_draci_loze.png",

    idec: "",
    appLinkIOS:
      "https://apps.apple.com/cz/app/%C5%99edisaurus-rex-dra%C4%8D%C3%AD-l%C3%B3%C5%BEe/id6738505977?l=cs",
    appLinkAndroid:
      "https://play.google.com/store/apps/details?id=cz.ceskatelevize.redisaurusrexdraciloze",
    altType: "",
    altTitle: "",
    altIdec: "",
    altUuid: "",
    altSlug: "",
    altThumbnail: "activity-placeholder.png",
    altAppLinkIOS: "",
    altAppLinkAndroid: "",
  },
  {
    name: "16",
    coordinates: {
      x: "2400",
      y: "1060",
    },
    width: "150",
    order: 16,
    title: "Šála po špuntovsku",
    isContest: false,
    uuid: "0db539f1-a22f-4da8-9f7f-be0ee8b61be7",
    type: "game",
    slug: "sala-po-spuntovsku",
    thumbnail: "icon_activity_sala_po_spuntovsku.png",

    description: "Upleť si pruhovanou šálu a ozdob ji postavičkami špuntů.",

    idec: "",
    appLinkIOS: "",
    appLinkAndroid: "",
    altType: "",
    altTitle: "",
    altIdec: "",
    altUuid: "",
    altSlug: "",
    altThumbnail: "activity-placeholder.png",
    altAppLinkIOS: "",
    altAppLinkAndroid: "",
  },
  {
    name: "17",
    coordinates: {
      x: "2560",
      y: "1060",
    },
    width: "150",
    order: 17,
    title: "Čtyřlístek kontra Klamérie",
    description: "Dokáže čtveřice z Třeskoprsk vyzrát na podvodníky?",
    isContest: false,
    uuid: "857f1e23-cfd3-496f-9654-0bad6431dc70",
    type: "game",
    slug: "ctyrlistek-kontra-klamerie",
    thumbnail: "icon_activity_ctyrlistek_kontra_klamerie.png",

    idec: "",
    appLinkIOS:
      "https://apps.apple.com/us/app/%C4%8Dty%C5%99l%C3%ADstek-kontra-klam%C3%A9rie/id6739452031",
    appLinkAndroid:
      "https://play.google.com/store/apps/details?id=cz.ceskatelevize.ctyrlistekkontraklamerie",
    altType: "game",
    altTitle: "",
    altDescription: "",
    altIdec: "",
    altUuid: "",
    altSlug: "",
    altThumbnail: "activity-placeholder.png",
    altAppLinkIOS: "",
    altAppLinkAndroid: "",
  },
  {
    name: "18",
    coordinates: {
      x: "2720",
      y: "1060",
    },
    width: "150",
    order: 18,
    title: "Tchoř Arnošt na ledu",
    isContest: true,
    uuid: "65328a84-8e5b-4904-808d-daa9ebc16c88",
    type: "game",
    slug: "tchor-arnost-na-ledu",
    thumbnail: "icon_activity_tchor_arnost_na_ledu.png",

    description: "Arnošt opět zachraňuje sýrárnu před bandou Notorických myšů.",

    idec: "",
    appLinkIOS: "",
    appLinkAndroid: "",
    altType: "game",
    altTitle: "Planeta 2412-ETA",
    altIdec: "",
    altUuid: "",
    altSlug: "",
    altDescription:
      "Princezna Prga vyráží do hlubin kosmu za ztracenou kometu.",
    altThumbnail: "icon_activity_planeta_2412-eta.png",
    altAppLinkIOS:
      "https://apps.apple.com/cz/app/planeta-2412-eta/id1542180014",
    altAppLinkAndroid:
      "https://play.google.com/store/apps/details?id=cz.ceskatelevize.planeta2412eta",
  },
  {
    name: "19",
    coordinates: {
      x: "2880",
      y: "1060",
    },
    width: "150",
    order: 19,
    title: "Vzpomněnka",
    isContest: false,
    uuid: "43891082-2570-44bb-8ca2-bc5c14c768ac",
    type: "game",
    slug: "vzpomnenka",
    thumbnail: "icon_activity_vzpomnenka.png",

    description: "Zapamatuješ si všechny detaily z vánočních obrázků?",

    idec: "",
    appLinkIOS: "https://itunes.apple.com/us/app/vzpomn%C4%9Bnka/id6444863866",
    appLinkAndroid:
      "https://play.google.com/store/apps/details?id=cz.ceskatelevize.vzpomnenka",
    altType: "",
    altTitle: "",
    altIdec: "",
    altUuid: "",
    altSlug: "",
    altThumbnail: "activity-placeholder.png",
    altAppLinkIOS: "",
    altAppLinkAndroid: "",
  },
  {
    name: "20",
    coordinates: {
      x: "3040",
      y: "1060",
    },
    width: "150",
    order: 20,
    title: "Tři zlaté dukáty",
    isContest: false,
    uuid: "",
    type: "video",
    slug: "tri-zlate-dukaty",
    thumbnail: "icon_activity_tri_zlate_dukaty.png",

    description: "Zachrání pastýř Juraj zakletou Julii v romantické pohádce?",

    idec: "223 513 13001",
    appLinkIOS: "",
    appLinkAndroid: "",
    altType: "",
    altTitle: "",
    altIdec: "",
    altUuid: "",
    altSlug: "",
    altThumbnail: "activity-placeholder.png",
    altAppLinkIOS: "",
    altAppLinkAndroid: "",
  },
  {
    name: "21",
    coordinates: {
      x: "3200",
      y: "1060",
    },
    width: "150",
    order: 21,
    title: "Dračí Vánoce",
    description: "Nakrmíš mlsné draky? Máme tu spoustu vánočních pochoutek!",
    isContest: false,
    uuid: "29631a67-495f-46e1-950f-ea44f15eb7f4",
    type: "game",
    slug: "draci-vanoce",
    thumbnail: "icon_activity_draci_vanoce.png",

    idec: "",
    appLinkIOS:
      "https://apps.apple.com/cz/app/dra%C4%8D%C3%AD-v%C3%A1noce/id6739503118",
    appLinkAndroid:
      "https://play.google.com/store/apps/details?id=cz.ceskatelevize.dracivanoce",
    altType: "",
    altTitle: "",
    altIdec: "",
    altUuid: "",
    altSlug: "",
    altThumbnail: "activity-placeholder.png",
    altAppLinkIOS: "",
    altAppLinkAndroid: "",
  },
  {
    name: "22",
    coordinates: {
      x: "3360",
      y: "1060",
    },
    width: "150",
    order: 22,
    title: "Špuntoskoč pod nulou",
    description: "Pomoz špuntům sbírat dárky a zachraň Vánoce na Déčku!",

    isContest: false,
    uuid: "187bcec6-2096-4f97-8095-6576b3d37bbc",
    type: "game",
    slug: "spuntoskoc-pod-nulou",
    thumbnail: "icon_activity_spuntoskoc_pod_nulou.png",

    idec: "",
    appLinkIOS: "https://itunes.apple.com/app/id6444106251",
    appLinkAndroid:
      "https://play.google.com/store/apps/details?id=cz.ceskatelevize.spuntoskocpodnulou",
    altType: "",
    altTitle: "",
    altIdec: "",
    altUuid: "",
    altSlug: "",
    altThumbnail: "activity-placeholder.png",
    altAppLinkIOS: "",
    altAppLinkAndroid: "",
  },
  {
    name: "23",
    coordinates: {
      x: "3520",
      y: "1060",
    },
    width: "150",
    order: 23,
    title: "Vánoční kouzlo",
    isContest: false,
    uuid: "",
    type: "video",
    slug: "vanocni-kouzlo",
    thumbnail: "icon_activity_vanocni_kouzlo.png",

    description:
      "Nauč se díky fyzikálním zákonům čarovat. Vyrob Vánoční kouzlo!",

    idec: "BONUS_45490",
    appLinkIOS: "",
    appLinkAndroid: "",
    altType: "",
    altTitle: "",
    altIdec: "",
    altUuid: "",
    altSlug: "",
    altThumbnail: "activity-placeholder.png",
    altAppLinkIOS: "",
    altAppLinkAndroid: "",
  },
  {
    name: "24",
    coordinates: {
      x: "3680",
      y: "1060",
    },
    width: "150",
    order: 24,
    title: "Klíč svatého Petra",
    isContest: false,
    uuid: "",
    type: "video",
    slug: "klic-svateho-petra",
    thumbnail: "icon_activity_klic_svateho_petra.png",

    description: "Okrást sv. Petra není jen tak! Pohádka ti řekne proč.",

    idec: "222 513 13003",
    appLinkIOS: "",
    appLinkAndroid: "",
    altType: "",
    altTitle: "",
    altIdec: "",
    altUuid: "",
    altSlug: "",
    altThumbnail: "activity-placeholder.png",
    altAppLinkIOS: "",
    altAppLinkAndroid: "",
  },
];
